import { type IBucket, IBucketID } from '@bridebook/models/source/models/Countries/Buckets.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';

const result: IBucket = {
  id: IBucketID.FUTURE,
  settings: {
    automaticDowngradeToUnverified: null,
    weddingFairs: null,
    templatedResponses: {
      venue: {
        [PremiumTiers.Unverified]: 1,
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_0_5]: 1,
        [PremiumTiers.Tier_1]: 1,
        [PremiumTiers.Tier_2]: 1,
        [PremiumTiers.Tier_2_5]: 1,
        [PremiumTiers.Tier_3]: 1,
        [PremiumTiers.Tier_4]: 1,
      },
      types: {
        excluded: ['group'],
      },
    },
    autoFollowUpTemplatedResponses: {
      venue: {
        [PremiumTiers.Tier_2_5]: 1,
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: Infinity,
      },
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        excluded: ['group'],
      },
    },
    instagramIntegration: null,
    realWeddings: null,
    realWeddingsCarousel: true,
    trendingCarousel: true,
    trendingCarouselSuppliers: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        included: ['venue'],
      },
    },
    roiSummary: null,
    badges: null,
    couplesIntel: null,
    lostLeadsStats: null,
    lostLeadTracking: null,
    yourCompetitors: null,
    topSpot: null,
    multiCounty: null,
    venueTypeHero: null,
    couplesActivity: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    revealCoupleEmailAddress: null,
    revealCouplePhoneNumber: null,
    lostLeadsInsightsEnquirySource: null,
    contactCouples: null,
    coupleTargeting: null,
    coupleTargetingGuestCount: null,
    lateAvailability: null,
    couplesInsightsSearchAppearances: null,
    couplesInsightsProfileViews: null,
    couplesInsightsEnquiries: null,
    deals: null,
    searchOptimisation: null,
    bridebookDiscounts: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    videoTours: null,
    professionalNetwork: null,
    specialOfferRecommendation: null,
    searchPerformance: null,
    socialMediaSupport: null,
    marketInsightsStats: null,
    marketInsightsStatsCoupleBudget: null,
    bridebookInstitute: null,
    upgradePlan: null,
    weddingReports: null,
    searchBoost: null,
    adminBanners: true,
    businessSelfSignUp: null,
    featureTutorials: null,
    aboutYou: null,
    countyDropdown: null,
    searchPresets: null,
    smartEmails: null,
    locations: null,
    onboardingConciergeFlow: null,
    enquiryWidget: {
      types: {
        included: ['venue'],
      },
    },
    trends: null,
    historicalSearchPositionChart: null,
    keepRelationsOnTierDowngrade: null,
    replyToReviews: null,
    inspirationAndAdvice: null,
    specialOffersCarousel: null,
    rapidResponder: null,
    featuredSupplierMarker: null,
    youMayAlsoLikeCarousel: {
      venue: [],
    },
    couplesAlsoLikeCarousel: {
      venue: [],
    },
    additionalImageOnSearch: null,
    quickFilters: null,
    recommendedSuppliersCarousel: null,
    recommendations: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
  },
};

export default {
  [result.id]: result,
};
